import { render, staticRenderFns } from "./CoozzyFacebookIcon.vue?vue&type=template&id=2388414e&scoped=true"
import script from "./CoozzyFacebookIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFacebookIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFacebookIcon.vue?vue&type=style&index=0&id=2388414e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388414e",
  null
  
)

export default component.exports